import Axios from 'axios';
import ApiError from './ApiError';
import ERRORS from './errorConstants';
import { appConstant } from '@constants';

const setupInterceptors = (store) => {
    // Default settings for Axios request
    Axios.defaults.baseURL = appConstant.domain;
    Axios.defaults.headers.post['Content-Type'] = 'application/json';
    Axios.defaults.validateStatus = () => true;

    Axios.interceptors.request.use(
        config => {
            return config
        }
        , error => Promise.reject(error),
    );
    Axios.interceptors.response.use(response => {
        // Process response body
        if (response.status && parseInt(response.status, 0) > 205) {
            switch (response.status) {
                case 500:
                    throw new ApiError(ERRORS.SERVER_ERROR);
                case 401:
                    throw new ApiError(ERRORS.UNAUTHORISED_ERROR, response.data.error.message);
                case 403:
                    throw new ApiError(ERRORS.FORBIDDEN_ERROR, response.data.error.message);
                case 406:
                    throw new ApiError(ERRORS.UNAUTHORISED_ERROR, response.data.error.message);
                case 400:
                    throw new ApiError(ERRORS.UNAUTHORISED_ERROR, response.data.error.message);
                case 404:
                    // throw response.data.;
                    throw new ApiError(ERRORS.CLIENT_ERROR);
                default:
                    throw new ApiError(ERRORS.CLIENT_ERROR);
            }
        } else {
            return response;
        }
    }, error => Promise.reject(error));
};

/**
 * Set auth token as default in Axios
 * @param token
 */
export const setAuthToken = (token = localStorage.getItem('authToken')) => {
    if (localStorage.getItem('authToken')) {
        Axios.defaults.headers.common.Authorization = atob(JSON.parse(token));
    }
};

setAuthToken();

export default setupInterceptors;
